import React from "react";
import { GiVendingMachine } from "react-icons/gi";
import { MdWeb } from "react-icons/md";


import {
  FaCode,
  FaPaintBrush,
  FaUserCircle,
  FaNetworkWired,
  FaHeadset,
  FaChalkboardTeacher,
  FaChartLine,
 FaTruck,
  
 
} from "react-icons/fa";

const iconComponents = {
  FaCode: FaCode,
  FaPaintBrush: FaPaintBrush,
  FaUserCircle: FaUserCircle,
  FaNetworkWired: FaNetworkWired,
  FaHeadset: FaHeadset,
  FaChalkboardTeacher: FaChalkboardTeacher,
  FaChartLine: FaChartLine,
  FaTruck: FaTruck, // Para Logística de máquinas
  
  GiVendingMachine: GiVendingMachine, // Asegúrate de añadir esta línea
  MdWeb: MdWeb,
};

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Lo que ofrecemos</h2>
          <p>
            
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => {
                const IconComponent = iconComponents[d.icon];
                return (
                  <div key={`${d.name}-${i}`} className="col-md-4" style={{ marginBottom: "30px" }}>
                    <div className="service-desc">
                      <IconComponent style={{ fontSize: "50px", color: "#f36f21" }} />
                      <div style={{ minHeight: "120px" }}>
                        <h3>{d.name}</h3>
                        <p>{d.text}</p>
                      </div>
                    </div>
                  </div>
                );
              })
            : "loading"}
        </div>
      </div>
    </div>
  );
};
